import React, { useState, useEffect } from "react";
import { CFormLabel, CFormInput, CButton } from "@coreui/react";
import { Plus, Pencil, Trash, Check } from "lucide-react";
import toast from "react-hot-toast";
import { toastConfig } from "../../constants/other.config";
import { CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from "@coreui/react";

const CloudinaryUploaderLocally = ({ onUploadSuccess, filesAl = [], onDelete, showStyleButton = false }) => {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedFileName, setEditedFileName] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (filesAl.length > 0) {
      setFiles(
        filesAl.map((file) => ({
          file,
          url: file.url || URL.createObjectURL(file.file),
          fileName: file.fileName || file.name || "Unknown",
          uploaded: true,
        }))
      );
    }
  }, [filesAl]);

  const handleFileSelect = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (!selectedFiles.length) return;

    const newFiles = selectedFiles.map((file) => ({
      file,
      fileName: file.name,
      preview: URL.createObjectURL(file),
      uploaded: false,
    }));

    setFiles((prev) => [...prev, ...newFiles]);
  };

  const handleEditClick = (index, currentName) => {
    setEditingIndex(index);
    setEditedFileName(currentName);
  };

  const handleSaveName = (index) => {
    const updatedFiles = [...files];
    updatedFiles[index].fileName = editedFileName;
    setFiles(updatedFiles);
    setEditingIndex(null);
  };

  const handleDelete = (index, fileObj) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
    if (onDelete) onDelete(fileObj);
    toast.success("File deleted", toastConfig);
  };

  const handleUpload = async () => {
    if (!files.length) {
      toast.error("No files to upload", toastConfig);
      return;
    }

    setUploading(true);

    // Simulate upload locally
    const uploadedFiles = files.map((f) => ({
      file: f.file,
      fileName: f.fileName,
      date: new Date(),
    }));

    // Return array back to parent
    if (onUploadSuccess) onUploadSuccess(uploadedFiles);

    toast.success("Files processed locally!", toastConfig);

    // setFiles((prev) =>
    //   prev.map((f) => ({
    //     ...f,
    //     uploaded: true,
    //   }))
    // );
    setFiles([]);

    setUploading(false);
    setVisible(false);
  };

  return (
    <div className="d-flex align-items-start gap-3">
      {/* Button */}
      {showStyleButton ? (
        <div
          className="d-flex flex-column align-items-center justify-content-center shadow"
          onClick={() => setVisible((p) => !p)}
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "20px",
            background: "var(--ui-color-primary, #2b7cd3)",
            cursor: "pointer",
          }}
        >
          <Plus className="text-white" strokeWidth={2} size={40} />
        </div>
      ) : (
        <CButton variant="outline" onClick={() => setVisible((p) => !p)}>
          <Plus />
          Add/Edit Files
        </CButton>
      )}

      {/* Modal */}
      <CModal visible={visible} size="lg" scrollable onClose={() => setVisible(false)}>
        <CModalHeader
          style={{
            backgroundColor: '#191919',
            borderBottom: '1px solid gray',
            color: 'white',
          }}
        >
          <CModalTitle
          style={{
            color:"white"
          }}
          >File Uploader</CModalTitle>
        </CModalHeader>

        <CModalBody
          style={{
            backgroundColor: '#191919',
            borderBottom: '1px solid gray',
            color: 'white',
          }}
        >
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <CFormLabel
              className="d-flex flex-column align-items-center justify-content-center shadow"
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "20px",
                background: "var(--ui-color-primary, #2b7cd3)",
                cursor: "pointer",
              }}
            >
              <Plus className="text-white" strokeWidth={2} size={40} />
              <CFormInput
                multiple
                className="hidden"
                type="file"
                onChange={handleFileSelect}
                accept="image/*, video/*, .pdf, .doc, .docx"
              />
            </CFormLabel>

            {files.map((file, idx) => {
              const fileUrl = file.preview || file.url;
              return (
                <div key={idx} className="d-flex flex-column align-items-center text-center">
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "4px",
                      overflow: "hidden",
                      border: "1px solid #ddd",
                    }}
                  >
                    {fileUrl && (
                      <img
                        src={fileUrl}
                        alt={file.fileName}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    )}
                  </div>

                  <div className="d-flex align-items-center gap-1 mt-1">
                    {editingIndex === idx ? (
                      <>
                        <input
                          className="form-control form-control-sm"
                          value={editedFileName}
                          onChange={(e) => setEditedFileName(e.target.value)}
                          onKeyDown={(e) => e.key === "Enter" && handleSaveName(idx)}
                        />
                        <Check className="cursor-pointer text-success" size={16} onClick={() => handleSaveName(idx)} />
                      </>
                    ) : (
                      <>
                        <span className="text-truncate" style={{ maxWidth: "80px" }}>
                          {file.fileName}
                        </span>
                        {!file.uploaded && (
                          <Pencil
                            className="cursor-pointer text-primary"
                            size={14}
                            onClick={() => handleEditClick(idx, file.fileName)}
                          />
                        )}
                        <Trash
                          className="cursor-pointer text-danger"
                          size={14}
                          onClick={() => handleDelete(idx, file)}
                        />
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </CModalBody>

        <CModalFooter
        style={{

            backgroundColor: '#191919',
            borderTop: '1px solid gray',
            gap: '10px',
            padding: '10px',
        }}
        >
          <CButton variant="outline" color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
           <CButton 
             onClick={handleUpload} 
             disabled={uploading}
             style={{
               backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
               borderColor: 'var(--ui-color-primary, #2b7cd3)',
               color: 'white',
             }}
             className="text-white"
           >
            {uploading ? "Processing..." : "Upload"}
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  );
};

export default CloudinaryUploaderLocally;
